import { useAuth } from '@/auth/AuthContext';

/**
 * Authenticated home dashboard stub inside the app shell.
 */
export function HomePage() {
  const { session } = useAuth();

  return (
    <div data-testid="agents-home">
      <header data-testid="agents-home-header" className="mb-8">
        <h1 className="text-2xl font-semibold text-primary">Home</h1>
        <p className="mt-2 text-secondary">
          Welcome to Kincode Agents. Build and deploy no-code agents for your workspace.
        </p>
      </header>

      <section data-testid="agents-home-main" className="grid gap-4 md:grid-cols-2">
        <article className="ds-surface rounded-kc p-5">
          <h2 className="text-sm font-semibold uppercase tracking-wide text-muted">Getting started</h2>
          <p className="mt-2 text-sm text-secondary">
            Open the Agents catalog to create your first agent when the builder ships in a later phase.
          </p>
        </article>

        {session ? (
          <article
            data-testid="agents-home-session-summary"
            className="ds-surface rounded-kc p-5 text-sm text-secondary"
          >
            <h2 className="text-sm font-semibold uppercase tracking-wide text-muted">Workspace</h2>
            <p className="mt-2">
              Signed in as company <strong className="text-primary">{session.companyID}</strong>, employee{' '}
              <strong className="text-primary">{session.employeeID}</strong>.
            </p>
          </article>
        ) : null}
      </section>
    </div>
  );
}
